export default function FluxVPNLogo({ size, className }: Icon) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			className={className}
			viewBox="0 0 32 32"
			fill="none"
		>
			<path
				d="M11.8553 1.58528C7.60738 3.4619 3.20088 6.75994 0.961363 10.9229C-1.12055 14.7928 0.070372 20.574 5.60072 20.1303C10.1184 19.7689 12.1467 16.3355 14.6984 13.1978C17.2982 10.0014 21.0776 6.93381 25.521 8.23833C26.1717 8.42915 26.7456 8.6691 27.243 8.95819C27.4985 9.10799 27.5186 9.08125 27.3032 8.87756C23.3622 5.14738 18.2891 5.21279 14.2124 8.67214C12.4917 10.1329 10.6752 11.6865 8.71224 12.8094C6.56996 14.0346 2.84096 13.6841 3.9336 10.1302C5.56377 4.82811 11.7431 1.55512 16.6478 0.0780945C16.6532 0.0760612 16.6553 0.0723304 16.6532 0.0669081L16.6423 0.0258996C16.637 0.00488691 16.623 -0.0032465 16.601 0.0011591C14.9705 0.380075 13.3885 0.908115 11.8553 1.58528Z"
				fill="currentColor"
			/>
			<path
				d="M13.4966 17.0476C15.6833 14.6841 18.7575 12.176 22.1855 12.3592C23.4666 12.4275 26.0219 13.0263 25.3969 14.9126C24.9969 16.1196 23.387 17.0558 22.1869 17.4399C21.8718 17.54 21.1571 17.6702 20.0428 17.8295C17.0723 18.2531 12.854 19.0393 10.6636 21.2866C7.85057 24.1721 8.89605 28.467 10.2854 31.8269C10.2945 31.8479 10.3099 31.8547 10.332 31.8474L10.3661 31.8366C10.3772 31.8319 10.3812 31.8243 10.3783 31.8133C9.44536 28.4767 9.9046 24.2637 13.5611 22.789C15.0982 22.1681 17.011 21.9387 18.9001 21.7677C21.6308 21.5216 24.4103 21.4014 27.0822 20.7535C29.7332 20.1096 31.9513 18.2942 31.9992 15.4006C32.0582 11.8329 28.659 9.96563 25.5106 9.87403C20.277 9.72237 15.9999 12.6024 13.3639 16.948C13.078 17.4181 13.122 17.4513 13.4966 17.0476Z"
				fill="currentColor"
			/>
		</svg>
	);
}
